import { createSelector } from "reselect";
import { DEVCON_V4 } from "./constants";
import { initialState } from "./reducer";
import {
  selectCurrentUser,
  selectPresentationMode,
} from "../../redux/selectors/app.selectors";

// The admin device page renders <Group /> without injecting this reducer.
const selectState = (state) => state[DEVCON_V4] || initialState;

export const selectVisibilityState = () => createSelector(selectState, (s) => s);

export const selectHiddenGroups = () =>
  createSelector(selectState, (s) => new Set(s.get("hiddenGroups").toJS()));

export const selectHiddenSettings = () =>
  createSelector(selectState, (s) => new Set(s.get("hiddenSettings").toJS()));

// Until the read finishes the panel must not render an unfiltered configuration.
export const selectVisibilitySettled = () =>
  createSelector(selectState, (s) => !!s.get("settled"));

// The account's own users always get the filtered configuration; a manager gets
// it too in presentation mode, which is how they preview it.
export const selectVisibilityEnforced = () =>
  createSelector(
    selectCurrentUser(),
    selectPresentationMode(),
    (user, presentationMode) => !user?.canPresentAsCustomer || !!presentationMode
  );

// Eye toggles: a manager with presentation mode off, same rule as the V3
// section toggle. `fetched` too — editing a policy we failed to read would
// persist an empty one over the stored one.
export const selectVisibilityEditable = () =>
  createSelector(
    selectState,
    selectCurrentUser(),
    selectPresentationMode(),
    (s, user, presentationMode) =>
      !!user?.canPresentAsCustomer && !presentationMode && !!s.get("fetched")
  );
